/* globals jui */
var Rx = require('ub_wrapped/rx');

var jQuery = require('jquery');
// This module is a standalone plugin that implements LP-5494, the
// breakpoint change notification UI.
var rxSwitchboard = require('ub/control/rx-switchboard');

;(function() {
  //TODO: refactor - pull out changes we care about event stream into its own subject.
  var _ = require('lodash');
  var pomChangeEvs = require('ub/events/pom-change-events');

  var options = {
    breakpointsToRoleMap: {
      mobile: 'mobile-breakpoint-button',
      desktop: 'desktop-breakpoint-button'
    },
    breakpointToggleCssClass: 'layout-changed-notification',
    layoutChangedMsgCssClass: 'lp-layout-changed-msg',
    notificationDisplayTime: 5000
  };

  var layoutChangedMsg = function() {
    return jQuery('<div>Changes have affected the other view</div>')
      .addClass(options.layoutChangedMsgCssClass);
  };

  var resetUI = function() {
    jQuery('.' + options.layoutChangedMsgCssClass).remove();
    jQuery('.' + options.breakpointToggleCssClass)
      .removeClass(options.breakpointToggleCssClass);
  };

  var displayUI = function() {
    resetUI(); // reset first to protect against dups

    var targetBreakpoint = Object.keys(options.breakpointsToRoleMap)
      .filter(function(breakpoint) {
        return breakpoint !== window.editor.page.getCurrentBreakpoint().name;
      })[0];

    jQuery('[data-role="' + options.breakpointsToRoleMap[targetBreakpoint] + '"]')
      .addClass(options.breakpointToggleCssClass)
      .append(layoutChangedMsg());
  };

  var _valueExistsForNonDesktop = function(model, accessor, breakpoint) {
    var otherBreakpoints = _.reject(model.element.page.getBreakPoints(), function(item) {
      return _.contains([breakpoint.name, 'desktop'], item.name);
    });

    return _.any(otherBreakpoints, function(otherBreakpoint) {
      var result = model.existsByBreakpoint(accessor, otherBreakpoint);
      if (result) {
        var breakpointModel = model.getBasicBreakpointModel(breakpoint),
          otherBreakpointModel = model.getBasicBreakpointModel(otherBreakpoint),
          breakpointVal = jui.deepQuery(breakpointModel, accessor),
          otherBreakpointVal = jui.deepQuery(otherBreakpointModel, accessor);
        if (_.isObject(otherBreakpointVal) && !_.isArray(otherBreakpointVal)) {
          return _.isEmpty(_.difference(_.keys(breakpointVal), _.keys(otherBreakpointVal)));
        } else {
          return true;
        }
      } else {
        return false;
      }
    });
  };

  var _isDesktopModifyable = function(isModifyable, page) {
    return !isModifyable || page.isDesktopBreakpoint();
  };

  var _attributeChanged = function(data) {
    return _.isEqual(data.value, data.previous);
  };

  var _canLayoutChange = function(element, data) {

    var model = element.model;
    if ( ! model) {
      return false;
    }
    var isModifyable      = model.isModifyable(data.accessor)
      , desktopModifiable = _isDesktopModifyable(isModifyable, window.editor.page)
      , accessor          = data.accessor
      , breakpoint        = element.page.getCurrentBreakpoint()
      , valueExists       = _valueExistsForNonDesktop(model, accessor, breakpoint);

    return (!_attributeChanged(data) && desktopModifiable? !valueExists : false);
  };

  var _mobileDesktopHaveDifferentBgTypes = function(model) {
    var desktopStyle = model.getBasicBreakpointModel('desktop').style;
    var mobileStyle = model.getBasicBreakpointModel('mobile').style;
    var isMobileBGTypePresent = _.isObject(mobileStyle.newBackground) && ! _.isUndefined(mobileStyle.newBackground.type);
    var isDesktopBGTypePresent = _.isObject(desktopStyle.newBackground) && ! _.isUndefined(desktopStyle.newBackground.type);
    if (isDesktopBGTypePresent && isMobileBGTypePresent) {
      return desktopStyle.newBackground.type !== mobileStyle.newBackground.type;
    } else {
      return false;
    }
  };

  var _ignoreAttrs = function(element, data) {
    /* jshint maxcomplexity:10 */
    // TODO: this should be simplified/broken into named detector functions
    return (_.contains(['geometry.contentWidth'], data.accessor) && element.type === 'lp-pom-root') ||
      (data.accessor.startsWith('geometry.maintainAR') && element.type === 'lp-pom-image') ||
      (data.accessor.startsWith('geometry.aspectRatio') && element.type === 'lp-pom-image') ||
      (data.accessor.startsWith('geometry.size.width') && element.type === 'lp-pom-block') ||
      (data.accessor.match(/content\.confirmationAction/) && element.type === 'lp-pom-form') ||
      (_.contains(['geometry.offset'], data.accessor) && element.type === 'lp-pom-button' && element.isFormButton()) ||
      (_.contains(data.accessor, 'savedBackgroundColor')) ||
      (_.contains(data.accessor, 'style.newBackground') && _mobileDesktopHaveDifferentBgTypes(element.model)) ||
      (_.isEqual(data.accessor, "style.newBackground.image.parallax")) ||
      (_.isEqual(data.accessor, "style.newBackground.pattern.parallax"));
  };

  var juiEvents = rxSwitchboard.subjects.jui_events; // RxJS event sources

  var breakpointChangedEvs = juiEvents
    .filter(function(ev) {
      return ev.type === 'breakpointChanged';
    });

  var isShowable = function() {
    var page = window.editor.page;

    return (page.isMobileBreakpoint() && page.isDesktopEnabled()) ||
      (page.isDesktopBreakpoint() && page.isMobileEnabled());
  };

  var initialize = function() {
    // shown needs to keep state, but does not need to be exposed
    var shown = false;
    var clearNotification = function() {
      if (shown) {
        resetUI();
      }
      shown = false;
    };
    var displayNotification = function() {
      if (!shown) {
        shown = true;
        displayUI();
      }
    };

    var clearEvents = new Rx.Subject(); // used to schedule resetUI after a delay
    clearEvents
      .throttle(options.notificationDisplayTime)
      .merge(breakpointChangedEvs)
      .subscribe(clearNotification);

    var startListening = function() {
      var evStream = pomChangeEvs.getEventStream();
      Rx.Observable
        .merge(
          evStream.creationOrDeletionEventStream,
          evStream.modificationEventStream
            // {"lp-pom-box-7": {accessors: {"geometry.offset.width": [72, 120]}}, element: juiElement}
            .map(function(delta) {
              return _.reduce(delta, function(acc, data, elmId) {
                acc[elmId] = _.clone(data);
                acc[elmId].accessors = _.reduce(data.accessors, function(res, val, key) {
                  res[key.replace(/^breakpoints\.mobile\./i, '')] = val;
                  return res;
                }, {});
                return acc;
              }, {});
            })
            .map(function(delta) {
              return _.reduce(delta, function(acc, data, elmId) {
                var clonedData = {
                  element: data.element,
                  accessors: _.reduce(data.accessors, function(res, values, accessor) {
                    var obj = {};
                    obj.accessor = accessor;
                    obj.previous = _.first(values);
                    obj.value = _.last(values);
                    if(! _ignoreAttrs(data.element, obj) && _canLayoutChange(data.element, obj)) {
                      res[accessor] = values;
                    }
                    return res;
                  }, {})
                };
                if(! _.isEmpty(clonedData.accessors)) {
                  acc[elmId] = clonedData;
                }
                return acc;
              }, {});
            })
            .filter(function(delta) {
              return ! _.isEmpty(delta) && _.any(delta, function(data) {
                return ! _.isEmpty(data.accessors);
              });
            }),
          evStream.blockMovedEventStream,
          evStream.pausableParentChangeEvents
        ).subscribe(function() {
          if(isShowable()) {
            displayNotification();
            clearEvents.onNext(true);
          }
        });
    };

    rxSwitchboard.subjects
      .first_page_load
      .subscribe(startListening);

  };

  initialize();
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/breakpoint-change-notice.js
// module id = 1063
// module chunks = 0